import Introduction from "@/components/Explore/Navi/Introduction";
import Hero from "@/components/Hero";
import { useNaviAc, useNaviHistory, useNaviPaper } from "@/hooks/useNavi";
import useTranslation from "@/hooks/useTranslation";
import CommonLayout from "@/layouts/Common";
import { naviState } from "@/stores/navi";
import { NextPage } from "next";
import Head from "next/head";
import { useRecoilValue } from "recoil";
import { v4 as uuidv4 } from "uuid";
import styles from "./styles.module.less";

const { wrapper } = styles;

const Navi: NextPage = () => {
  useNaviHistory();
  const { t } = useTranslation("explore");
  const { suggestTerms, suggestedTerms } = useNaviAc();
  const { searchParams } = useRecoilValue(naviState);

  const { loadingSearch, handleSearch } = useNaviPaper();

  const bannerProps = {
    term: searchParams?.term,
    title: t("navi.banner.title"),
    slogan: t("navi.banner.slogan"),
    placeholder: t("navi.banner.placeholder"),
    statement: t("navi.banner.statement"),
    acOptions: suggestedTerms,
    handleSearch,
    loadingSearch,
    handleChange: suggestTerms,
  };

  return (
    <CommonLayout>
      <Head>
        <title>
          {t("menu:explore.navi")} - {t("menu:explore.itself")} - MedicGo
        </title>
      </Head>
      <div className={wrapper}>
        <Hero {...bannerProps} />
      </div>
      <div className={styles.container}>
        <Introduction />
      </div>
    </CommonLayout>
  );
};

Navi.getInitialProps = async (ctx) => {
  const id = uuidv4();
  const page = parseInt((ctx.query.page as string) || "1", 10);
  const size = parseInt((ctx.query.size as string) || "20", 10);
  return {
    page,
    size,
    id,
    namespacesRequired: ["explore", "common", "menu"],
  };
};

export default Navi;
